import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const accommodationRoomTypeEntity: Entity = {
  model: model,
  repository: repository,
}

export default accommodationRoomTypeEntity
